// © 2001-2015 INOVx Solutions, Inc.
// 114 Pacifica Suite 300, Irvine, CA 92618 USA
// All rights reserved.
//
// This software is confidential, proprietary and unpublished property of
// INOVx Solutions, Inc.  It may NOT be copied in part or in whole on any
// medium, either electronic or printed, without the express written consent
// of INOVx Solutions, Inc.
import * as BABYLON from 'babylonjs';
import Hammer from 'hammerjs';
import * as Enumerations from '../../Enumerations/Enumerations';
import * as Interfaces from '../../Interfaces/Interfaces';
import Collection from '../Structures/Collection';
var eventPrefix = "";

class FollowCamera extends BABYLON.FreeCamera {


    public inertialAlphaOffset = 0;
    public inertialBetaOffset = 0;
    public cameraNavigationMode = Enumerations.CameraNavigationMode.Walk;
    public _initialFocalDistance = 10;
    public tweenCameraMode: boolean = true;
    private _cameraHeight = 1.8;
    private _timeSinceFrameUpdate = 0;
    private left: any;
    private right: any;
    private up: any;
    private down: any;
    private escape: any;
    private _keyForwardFirstPressed: boolean = true;
    private _forwardMove: boolean = true;
    private _keyBackFirstPressed: boolean = true;
    private _headlight: BABYLON.DirectionalLight;

    private _eventHandler: Interfaces.Interfaces.IEventManager;
    private _wayPoints: BABYLON.Vector3[];

    private _onKeyDown: (e: KeyboardEvent) => any;
    private _onKeyUp: (e: KeyboardEvent) => any;
    private _keys: any[];
    private direction: BABYLON.Vector3;
    private angularSpeed: number;
    private angle: number;
    private _currentWaypoint: Interfaces.Interfaces.IWaypoint;
    private _currentJunction: Interfaces.Interfaces.IJunction;
    private _travelingPath: Interfaces.Interfaces.IPath;
    private _waypointDestination: Interfaces.Interfaces.IWaypoint;
    private _distanceToNextWaypoint: number;
    private _directionToNextWaypoint: BABYLON.Vector3;
    private _route: Interfaces.Interfaces.IFollowCameraRoute;
    private _pathState = 0;
    private _lookedAtPath: Interfaces.Interfaces.IPath;
    private _highlightPathMaterial: BABYLON.StandardMaterial;
    private _pathIndex = 0;
    private _travelIndex = 0;
    private _exitCameraCallback: () => void;
    private _attachedElement: HTMLElement;
    private _onClick: (e: PointerEvent) => void;
    private _onPointerDown: (e: PointerEvent) => void;
    private _onPointerUp: (e: PointerEvent) => void;
    private _onPointerMove: (e: PointerEvent) => void;
    private _onMouseMove: (e: MouseEvent) => any;
    private _onMouseLeave: (e: DragEvent) => any;
    private _onMouseEnter: (e: DragEvent) => any;
    private _onElementClicked: (e: MouseEvent) => any;
    private _onBodyClicked: (e: MouseEvent) => any;
    private _onLostFocus: (e: FocusEvent) => any;
    private _clickCount: number = 0;

    private _leftClickTime = 0;
    public _angularSensibilityX = 650.0;
    public _angularSensibilityY = 650.0;
    private _viewerSelected: boolean = true;
    private _mouseOver = false;
    private _velocity = 0;
    private rotationChange = 0;
    private _materialManager: Interfaces.Interfaces.IMaterialsManager;
    private _distanceOfNextPathTween = 0;
    private _distanceOfPathTween = 0;
    private _distanceToTweenToNextPath = 0;
    private _lerpDirection: BABYLON.Vector3;
    private _headlightAngle = 1.1;
    constructor(name: string, eventHander: Interfaces.Interfaces.IEventManager, startingJunctionId: string, route: Interfaces.Interfaces.IFollowCameraRoute, materialManager: Interfaces.Interfaces.IMaterialsManager, exitCameraCallback: () => void, scene: BABYLON.Scene) {
        super(name, new BABYLON.Vector3(0, 0, 0), scene);

        eventPrefix = BABYLON.Tools.GetPointerPrefix(scene.getEngine());
        var that = this;
        this._exitCameraCallback = exitCameraCallback;
        this._materialManager = materialManager;
        this._keys = [];
        this.up = [38, 87];
        this.down = [40, 83];
        this.left = [37, 65];
        this.right = [39, 68];
        this.escape = [27];
        this._highlightPathMaterial = new BABYLON.StandardMaterial("HighlightPath", this._scene);
        this._highlightPathMaterial.diffuseColor = new BABYLON.Color3(0, 1, 0);

        this._highlightPathMaterial.specularColor = new BABYLON.Color3(0.7529411764705882, 0.7529411764705882, 0.7529411764705882);
        this._highlightPathMaterial.emissiveColor = new BABYLON.Color3(0, 0, 0);
        this._highlightPathMaterial.ambientColor = new BABYLON.Color3(0, 1, 0);

        this._highlightPathMaterial.specularPower = 50;
        this._highlightPathMaterial.alpha = .5;
        this._highlightPathMaterial.id = "HighlightPath";

        this._keys = [];
        this._route = route;

        var junction = this.getJunction(startingJunctionId);
        this._currentJunction = junction;
        this._currentWaypoint = junction.paths[0].wayPoints[0];
        var pos = new BABYLON.Vector3(this._currentWaypoint.position.x, this._currentWaypoint.position.y, this._currentWaypoint.position.z);
        this.position = pos;
        this.position.y += this._cameraHeight;

        var targetDir = junction.paths[0].wayPoints[1].position.subtract(junction.paths[0].wayPoints[0].position).normalize();
        this.setTarget(this.position.add(targetDir.scale(10)));

        this.minZ = 0.1;
        this.speed = 2.0;
        this.angularSpeed = 0.4;
        this.angle = Math.PI / 2;
        this.inertia = 0;
        this._eventHandler = eventHander;
        this.inputs.removeByType("FreeCameraKeyboardMoveInput");
        (this.inputs.attached.mouse as any).angularSensibility = 600;

        this.onViewMatrixChangedObservable.add(function () {
            if (that._waypointDestination == null && (that._currentWaypoint.type == Enumerations.WaypointType.JUNCTION)) {
                that.highlightClosestPath();
            }

            if (that._headlight) {

                var lightPosition = that.position.clone();
                that._headlight.direction = that.getTarget().subtract(that.position).normalize();
                that._headlight.position = lightPosition;
            }

            var cameraDirection = that.getTarget().subtract(that.position).normalize();
            var directionVector = new BABYLON.Vector3(cameraDirection.x, 0, cameraDirection.z).normalize();

            var upDotProduct = BABYLON.Vector3.Dot(cameraDirection, directionVector);
            var directionDotProduct = BABYLON.Vector3.Dot(directionVector, new BABYLON.Vector3(0, 0, 1));
            upDotProduct = upDotProduct > 1 ? 1 : upDotProduct;
            directionDotProduct = directionDotProduct > 1 ? 1 : directionDotProduct;

            upDotProduct = upDotProduct > 1 ? 1 : upDotProduct;
            directionDotProduct = directionDotProduct > 1 ? 1 : directionDotProduct;

            var angleUp = Math.acos(upDotProduct);
            var angleFromNorth = Math.acos(directionDotProduct);

            // If the X is negative, then the rotation is 360 degrees MINUS the angle.
            angleFromNorth = directionVector.x < 0 ? 2 * Math.PI - angleFromNorth : angleFromNorth;

            var upAxis = Math.round(angleUp * 180 / (Math.PI)) == 0 ? "" : cameraDirection.y > 0 ? "U" : "D";

            var rotatedDegrees = Math.round(angleFromNorth * 180 / (Math.PI)) == 360 ? 0 : Math.round(angleFromNorth * 180 / (Math.PI));
            var upDegrees = angleUp * 180 / (Math.PI) > 89 ? 90 : Math.round(angleUp * 180 / (Math.PI));

            var args: any = {
                rotatedDegrees: rotatedDegrees,
                upDegrees: upDegrees + "° " + upAxis
            };
            that._eventHandler.fireEvent(Enumerations.EventType.CAMERACHANGED, args);
        });

        //Key Input Manager To Use Keys to Move Forward and BackWard and Look to the Left or Right
        var FreeCameraKeyboardWalkInput = function () {
            this._keys = [];
            this.escape = [27];
            this.keysUp = [38];
            this.keysDown = [40];
            this.keysLeft = [37];
            this.keysRight = [39];
        }

        this.highlightClosestPath();
        this.getEngine().getRenderingCanvas().focus();

    }

    public focusCanvas() {
        this.getEngine().getRenderingCanvas().focus();
    }
    public getRouteID(): string {
        return this._route.id;
    }

    public isMoving(): boolean {
        return (this.rotationChange != 0 || (this.cameraRotation.x != 0 || this.cameraRotation.y != 0) || this._velocity != 0);
    }
    public disposeHeadlights() {
        if (this._headlight) {
            this._scene.removeLight(this._headlight);
            this._headlight.dispose();
            this._headlight = null;
        }
    }

    public hasHeadlights() {
        return this._headlight;
    }

    public setHeadlight(light: BABYLON.DirectionalLight) {
        if (this._headlight)
            this._headlight.dispose();

        light.position = this.position;
        this._headlight = light;
    }

    private highlightClosestPath() {

        var closest = 0;
        var closestIndex = 0;
        for (var x = 0; x < this._currentJunction.paths.length; x++) {
            var dir = this._currentJunction.paths[x].wayPoints[1].position.subtract(this._currentWaypoint.position);
            dir = dir.normalize();
            var camDir = this.getTarget().subtract(this.position).normalize();
            var dot = BABYLON.Vector3.Dot(dir, camDir);

            if (dot > closest) {
                closest = dot;
                closestIndex = x;
            }
        }

        for (var x = 0; x < this._currentJunction.paths.length; x++) {
            if (x == closestIndex) {
                for (var m = 0; m < this._currentJunction.paths[x].meshes.length; m++) {
                    this._currentJunction.paths[x].meshes[m].material = this._highlightPathMaterial;
                }
            }
            else {
                for (var m = 0; m < this._currentJunction.paths[x].meshes.length; m++) {
                    this._currentJunction.paths[x].meshes[m].material = this._materialManager.getMaterial("PathMaterial");
                }
            }
        }

        this._lookedAtPath = this._currentJunction.paths[closestIndex];
    }
    private getJunction(junctionId: string): Interfaces.Interfaces.IJunction {

        for (var x = 0; x < this._route.junctions.length; x++) {
            if (this._route.junctions[x].id == junctionId)
                return this._route.junctions[x];
        }
    }
    private acceptLookedAtPath(forwardPress: boolean) {
        if (this._lookedAtPath != null) {

            var dir = this._currentWaypoint.position.subtract(this._lookedAtPath.wayPoints[1].position);
            dir = dir.normalize();
            var camDir = this.getTarget().subtract(this.position).normalize();
            var dot = BABYLON.Vector3.Dot(dir, camDir);


            if (forwardPress && dot > 0)
                return;

            if (!forwardPress && dot < 0)
                return;

            this._currentWaypoint = this._lookedAtPath.wayPoints[0];
            this._waypointDestination = this._lookedAtPath.wayPoints[1];
            this._travelingPath = this._lookedAtPath;
            this._travelIndex = 0;
            this._lookedAtPath = null;
            this.calculateNextWaypoint();
        }
    }
    private calculateNextWaypoint() {
        this._directionToNextWaypoint = this._waypointDestination.position.subtract(this._currentWaypoint.position);
        this._distanceToNextWaypoint = this.getDistanceToNextWaypoint();
        this._directionToNextWaypoint = this._directionToNextWaypoint.normalize();
    }
    private getDistanceToNextWaypoint(): number {
        if (this._waypointDestination == null)
            return 0;

        var position = new BABYLON.Vector3(this.position.x, this.position.y - this._cameraHeight, this.position.z);
        return this._waypointDestination.position.subtract(position).length();
    }
    private getDistanceOfPath(): number {
        if (this._waypointDestination == null)
            return 0;


        return this._waypointDestination.position.subtract(this._currentWaypoint.position).length();
    }

    private tweenCamera(distanceToTravel: number) {
        if (this.rotationChange != 0 || (this.cameraRotation.x != 0 || this.cameraRotation.y != 0))
            return;

        if (distanceToTravel > 0) {
            var distanceToNext = this.getDistanceToNextWaypoint();
            var nextTweenPossible = this._waypointDestination.type != Enumerations.WaypointType.JUNCTION && this._travelIndex < this._travelingPath.wayPoints.length - 2;
            if (distanceToNext < 3 && nextTweenPossible) {
                if (this._distanceToTweenToNextPath == 0) {
                    this._distanceToTweenToNextPath = Math.max(distanceToNext, 1.5);
                    this._lerpDirection = this.getTarget().subtract(this.position).normalize();
                }

                // tween to NEXT direction.
                this._distanceOfNextPathTween += distanceToTravel;

                this._distanceOfNextPathTween = Math.min(this._distanceOfNextPathTween, this._distanceToTweenToNextPath);
                var percentToTween = (this._distanceOfNextPathTween / this._distanceToTweenToNextPath);
                var desiredTargetDir = this._travelingPath.wayPoints[this._travelIndex + 2].position.subtract(this._waypointDestination.position).normalize();

                if (!this._forwardMove) {
                    desiredTargetDir = desiredTargetDir.scale(-1);
                }

                var tweenDir = BABYLON.Vector3.Lerp(this._lerpDirection, desiredTargetDir, percentToTween);
                this.setTarget(this.position.add(tweenDir));
            }
            else {
                if (this._lerpDirection == null) {
                    this._lerpDirection = this.getTarget().subtract(this.position).normalize();
                }

                this._distanceOfPathTween += distanceToTravel;

                this._distanceOfPathTween = Math.min(this._distanceOfPathTween, 3);
                var percentToTween = (this._distanceOfPathTween / 3);

                var dir = this._waypointDestination.position.subtract(this._currentWaypoint.position);
                dir = dir.normalize();
                var camDir = this.getTarget().subtract(this.position).normalize();

                var dot = BABYLON.Vector3.Dot(dir, camDir);

                var desiredTargetDir = this._waypointDestination.position.subtract(this._currentWaypoint.position).normalize();

                if (!this._forwardMove) {
                    desiredTargetDir = desiredTargetDir.scale(-1);
                }

                var tweenDir = BABYLON.Vector3.Lerp(this._lerpDirection, desiredTargetDir, percentToTween);
                this.setTarget(this.position.add(tweenDir.scale(10)));
            }
        }
        else {
            distanceToTravel = Math.abs(distanceToTravel);
            var distanceToNext = this.getDistanceOfPath() - this.getDistanceToNextWaypoint();
            var nextTweenPossible = this._currentWaypoint.type != Enumerations.WaypointType.JUNCTION && this._travelIndex > 1;
            if (distanceToNext < 3 && nextTweenPossible) {
                if (this._distanceToTweenToNextPath == 0) {
                    this._distanceToTweenToNextPath = Math.max(distanceToNext, 1.5)
                    this._lerpDirection = this.getTarget().subtract(this.position).normalize();
                }

                // tween to NEXT direction.
                this._distanceOfNextPathTween += distanceToTravel;

                this._distanceOfNextPathTween = Math.min(this._distanceOfNextPathTween, this._distanceToTweenToNextPath);
                var percentToTween = (this._distanceOfNextPathTween / this._distanceToTweenToNextPath);
                var desiredTargetDir = this._travelingPath.wayPoints[this._travelIndex - 1].position.subtract(this._currentWaypoint.position).normalize();

                var dir = desiredTargetDir;
                dir = dir.normalize();
                var camDir = this.getTarget().subtract(this.position).normalize();

                var dot = BABYLON.Vector3.Dot(dir, camDir);

                if (this._forwardMove) {
                    desiredTargetDir = desiredTargetDir.scale(-1);
                }

                var tweenDir = BABYLON.Vector3.Lerp(this._lerpDirection, desiredTargetDir, percentToTween);
                this.setTarget(this.position.add(tweenDir));
            }
            else {
                if (this._lerpDirection == null) {
                    this._lerpDirection = this.getTarget().subtract(this.position).normalize();
                }

                this._distanceOfPathTween += distanceToTravel;

                this._distanceOfPathTween = Math.min(this._distanceOfPathTween, 3);
                var percentToTween = (this._distanceOfPathTween / 3);
                var desiredTargetDir = this._waypointDestination.position.subtract(this._currentWaypoint.position).normalize();

                var dir = this._waypointDestination.position.subtract(this._currentWaypoint.position);
                dir = dir.normalize();
                var camDir = this.getTarget().subtract(this.position).normalize();

                var dot = BABYLON.Vector3.Dot(dir, camDir);

                var desiredTargetDir = this._waypointDestination.position.subtract(this._currentWaypoint.position).normalize();

                if (!this._forwardMove) {
                    desiredTargetDir = desiredTargetDir.scale(-1);
                }

                var tweenDir = BABYLON.Vector3.Lerp(this._lerpDirection, desiredTargetDir, percentToTween);
                this.setTarget(this.position.add(tweenDir.scale(10)));
            }
        }
    }

    private moveAlongPath(distance: number) {

        if (this._travelingPath == null)
            return;

        if (distance > 0) {
            if (this.processNextWaypoint())
                return;

            var distanceToNext = this.getDistanceToNextWaypoint();

            if (this.tweenCameraMode)
                this.tweenCamera(distance);

            var distanceToMove = distance;

            if (distanceToMove > this.getDistanceToNextWaypoint()) {

                this.position = new BABYLON.Vector3(this._waypointDestination.position.x, this._waypointDestination.position.y + this._cameraHeight, this._waypointDestination.position.z);
                this._distanceToNextWaypoint = 0;
            }
            else {
                this._directionToNextWaypoint = this._waypointDestination.position.subtract(new BABYLON.Vector3(this.position.x, this.position.y - this._cameraHeight, this.position.z)).normalize();
                this.position = this.position.add(this._directionToNextWaypoint.scale(distanceToMove));
                this._distanceToNextWaypoint -= distanceToMove;
            }

        }
        else {
            if (this.processPrevWaypoint())
                return;

            if (this.tweenCameraMode)
                this.tweenCamera(distance);

            if (Math.abs(distance) > Math.abs(this.getDistanceOfPath() - this.getDistanceToNextWaypoint())) {

                this.position = new BABYLON.Vector3(this._currentWaypoint.position.x, this._currentWaypoint.position.y + this._cameraHeight, this._currentWaypoint.position.z);
                this._distanceToNextWaypoint = this.getDistanceOfPath();
            }
            else {
                var distanceToMove = distance;
                this._directionToNextWaypoint = new BABYLON.Vector3(this.position.x, this.position.y - this._cameraHeight, this.position.z).subtract(this._currentWaypoint.position).normalize();
                this.position = this.position.add(this._directionToNextWaypoint.scale(distanceToMove));
                this._distanceToNextWaypoint -= distanceToMove;
            }
        }
    }
    public detachControl(element?: any): void {

        if (element != null) {
            element.removeEventListener("keydown", this._onKeyDown, false);
            element.removeEventListener("keyup", this._onKeyUp, false);
            element.removeEventListener("mouseenter", this._onMouseEnter, false);
        }

        if (this._reset) {
            this._reset();
        }
    }

    public get angularSensibilityX() {
        return this._angularSensibilityX;
    }

    public get angularSensibilityY() {
        return this._angularSensibilityY;
    }

    public exitCamera() {
        for (var x = 0; x < this._currentJunction.paths.length; x++) {

            for (var m = 0; m < this._currentJunction.paths[x].meshes.length; m++) {
                this._currentJunction.paths[x].meshes[m].material = this._materialManager.getMaterial("PathMaterial");
            }
        }
        this._exitCameraCallback();
    }
    public processNextWaypoint(): boolean {
        if (this.getDistanceToNextWaypoint() > 0.00001)
            return false;;

        if (this._travelingPath.wayPoints[this._travelIndex + 1].type == 2 && this._travelIndex == this._travelingPath.wayPoints.length - 2)
            return false;

        this._travelIndex++;
        this._distanceToTweenToNextPath = 0;
        this._distanceOfPathTween = 0;
        this._distanceOfNextPathTween = 0;
        this._lerpDirection = null;
        this._currentWaypoint = this._travelingPath.wayPoints[this._travelIndex];

        this.position = new BABYLON.Vector3(this._currentWaypoint.position.x, this._currentWaypoint.position.y, this._currentWaypoint.position.z);
        this.position.y += this._cameraHeight;


        if (this._travelIndex == this._travelingPath.wayPoints.length - 1) {
            //reached the end of our travel. Enter the junction, and stop if we're 
            // 1) not tweening
            // 2) Tweening, but there's not a single exit.

            // Deliberately commented out, and checked in. This will be used shortly.
            /*
            if (this._waypointDestination.type == Enumerations.WaypointType.JUNCTION && this.tweenCameraMode) {
                var endJunc = this.getJunction(this._waypointDestination.id);

                if (endJunc.paths.length == 2) {
                    var newPath = endJunc.paths[0].id == this._travelingPath.id ? endJunc.paths[1] : endJunc.paths[0];
                    // accept the next path that isn't where we just came from
                    this._currentWaypoint = newPath.wayPoints[0];
                    this._currentJunction = endJunc;
                    this._waypointDestination = newPath.wayPoints[1];
                    this._travelingPath = newPath;
                    this._travelIndex = 0;
                    this.calculateNextWaypoint();

                    return true;
                }
            }
            */

            this._travelingPath = null;
            this._waypointDestination = null;
            this._currentJunction = this.getJunction(this._currentWaypoint.id);
            this.highlightClosestPath();
        }
        else {
            this._waypointDestination = this._travelingPath.wayPoints[this._travelIndex + 1];
            this.calculateNextWaypoint();
        }

        return true;
    }

    public attachControl(element?: any, preventDefault?: boolean, useCtrlForPanning: boolean = false): void {
        var that = this;
        var previousPosition: any;
        var previousPan: any;
        var previousPan1: any;
        var previousPan2: any;
        var panCount: any;
        var previousRotate: any;

        if (useCtrlForPanning === void 0) { useCtrlForPanning = false; }
        var cacheSoloPointer: any; // cache pointer object for better perf on camera rotation
        var previousPinchDistance = 0;
        var previousPinchDirection = 0;
        var pointers = new Collection();

        element = this.getEngine().getRenderingCanvas() as any;
        if (that._attachedElement) {
            return;
        }
        that._attachedElement = element;
        var engine = that.getEngine();
        if (that._onPointerDown === undefined) {

            that._onPointerDown = function (evt) {

                if (evt.buttons === 1) {
                    that._leftClickTime = evt.timeStamp;
                }
                else {
                    that._leftClickTime = 0;
                }

                // manage pointers
                pointers.add(evt.pointerId, { x: evt.clientX, y: evt.clientY, type: evt.pointerType });
                cacheSoloPointer = pointers.item(evt.pointerId);
                if (preventDefault) {
                    evt.preventDefault();
                }
            };
            that._onPointerUp = function (evt) {
                //stop look at position if pointer up event

                //would be better to use pointers.remove(evt.pointerId) for multitouch gestures,
                //but emptying completly pointers collection is required to fix a bug on iPhone :
                //will be ok to put back pointers.remove(evt.pointerId); when iPhone bug corrected
                //pointers.empty();
                if (evt.buttons == 0) {
                    cacheSoloPointer = null;
                    previousPinchDistance = 0;
                    pointers.remove(evt.pointerId)
                }
                if (preventDefault) {
                    evt.preventDefault();
                }
            };
            that._onClick = function (evt) {

                if ((evt.timeStamp - that._leftClickTime) < 250) {

                    try {
                        var clickEvent = new MouseEvent("press", { screenX: evt.x, screenY: evt.y });
                    } catch (e) {
                        clickEvent = document.createEvent("MouseEvent");
                        clickEvent.initMouseEvent("press", true, true, window, 0, evt.clientX, evt.clientY, 0, 0, false, false, false, false, 0, evt.target);
                    }

                    window.dispatchEvent(clickEvent);
                }
            };

            that._onKeyDown = function (evt) {

                if (that._viewerSelected) {

                    if (that.up.indexOf(evt.keyCode) !== -1 ||
                        that.down.indexOf(evt.keyCode) !== -1 ||
                        that.left.indexOf(evt.keyCode) !== -1 ||
                        that.right.indexOf(evt.keyCode) !== -1) {
                        var index = that._keys.indexOf(evt.keyCode);
                        if (index === -1) {
                            that._keys.push(evt.keyCode);
                        }
                        if (evt.preventDefault) {
                            evt.preventDefault();
                        }

                        if (that.up.indexOf(evt.keyCode) !== -1) {

                            if (that._keyForwardFirstPressed) {
                                that.acceptLookedAtPath(true);
                                var dir = that._currentWaypoint.position.subtract(that._waypointDestination.position);
                                dir = dir.normalize();
                                var camDir = that.getTarget().subtract(that.position).normalize();

                                var dot = BABYLON.Vector3.Dot(dir, camDir);

                                var forward = dot <= 0;

                                if (forward != that._forwardMove) {
                                    that._distanceOfPathTween = 0;
                                    that._distanceOfNextPathTween = 0;
                                    that._distanceToTweenToNextPath = 0;
                                    that._forwardMove = forward;
                                }
                            }

                            if (that._waypointDestination != null) {

                                that._keyForwardFirstPressed = false;
                                that._velocity = that._forwardMove ? that.speed : that.speed * -1;
                            }
                        }

                        if (that.down.indexOf(evt.keyCode) !== -1) {

                            if (that._keyBackFirstPressed) {
                                that.acceptLookedAtPath(false);
                                if (that._waypointDestination != null) {
                                    var dir = that._currentWaypoint.position.subtract(that._waypointDestination.position);
                                    dir = dir.normalize();
                                    var camDir = that.getTarget().subtract(that.position).normalize();

                                    var dot = BABYLON.Vector3.Dot(dir, camDir);
                                    var forward = dot <= 0;

                                    if (forward != that._forwardMove) {
                                        that._distanceOfPathTween = 0;
                                        that._distanceOfNextPathTween = 0;
                                        that._distanceToTweenToNextPath = 0;
                                        that._forwardMove = forward;
                                    }
                                }
                            }

                            if (that._waypointDestination != null) {

                                that._keyBackFirstPressed = false;
                                that._velocity = that._forwardMove ? that.speed * -1 : that.speed;
                            }
                        }
                        if (that.right.indexOf(evt.keyCode) !== -1) {
                            that._distanceOfPathTween = 0;
                            that._distanceOfNextPathTween = 0;
                            that._distanceToTweenToNextPath = 0;
                            that._lerpDirection = null;
                            that.rotationChange = that.angularSpeed;
                        }
                        if (that.left.indexOf(evt.keyCode) !== -1) {
                            that._distanceOfPathTween = 0;
                            that._distanceOfNextPathTween = 0;
                            that._distanceToTweenToNextPath = 0;
                            that._lerpDirection = null;
                            that.rotationChange = that.angularSpeed * -1;
                        }
                    }

                    if (that.escape.indexOf(evt.keyCode) !== -1) {
                        that.exitCamera();
                    }
                }
            };
            that._onMouseLeave = function (evt) {
                evt.preventDefault();
                that._mouseOver = false;
            };
            that._onMouseEnter = function (evt) {
                that.getEngine().getRenderingCanvas().focus()
                that._mouseOver = true;
            };
            that._onKeyUp = function (evt) {

                if (that.up.indexOf(evt.keyCode) !== -1 ||
                    that.down.indexOf(evt.keyCode) !== -1 ||
                    that.left.indexOf(evt.keyCode) !== -1 ||
                    that.right.indexOf(evt.keyCode) !== -1) {
                    var index = that._keys.indexOf(evt.keyCode);
                    if (index >= 0) {
                        that._keys.splice(index, 1);
                    }
                    if (evt.preventDefault) {
                        if (preventDefault) {
                            evt.preventDefault();
                        }
                    }
                    if (that.up.indexOf(evt.keyCode) !== -1) {

                        that._keyForwardFirstPressed = true;
                        that._velocity = 0;
                    }
                    if (that.down.indexOf(evt.keyCode) !== -1) {
                        that._keyBackFirstPressed = true;
                        that._velocity = 0;
                    }
                    if (that.left.indexOf(evt.keyCode) !== -1) {

                        that.rotationChange = 0;
                    }
                    if (that.right.indexOf(evt.keyCode) !== -1) {

                        that.rotationChange = 0;
                    }
                }
            };

            that._onElementClicked = function () {

                that._clickCount = 1;
            };

            that._onBodyClicked = function (evt) {
                that._clickCount++;

                // if click == 2, means you have clicked on viewer
                // if click == 1, means you have clicked not on viewer
                if (that._clickCount == 2) {
                    that._viewerSelected = true;
                    evt.preventDefault();
                }
                else {
                    that._viewerSelected = false;
                }

                that._clickCount = 0;
            }

            that._onLostFocus = function () {

                that._keys = [];
                pointers.empty();
                previousPinchDistance = 0;
                cacheSoloPointer = null;
            };

            that._reset = function () {
                that._keys = [];
                that.inertialAlphaOffset = 0;
                that.inertialBetaOffset = 0;
                pointers.empty();
                previousPinchDistance = 0;
                cacheSoloPointer = null;
            };

            this.inputs.attachElement(preventDefault);
        }
        element.addEventListener("keydown", this._onKeyDown, false);
        element.addEventListener("keyup", this._onKeyUp, false);
        element.addEventListener("mouseenter", this._onMouseEnter, false);
    }

    public processPrevWaypoint(): boolean {
        if ((this.getDistanceOfPath() - this.getDistanceToNextWaypoint()) > .00001)
            return false;

        this._distanceToTweenToNextPath = 0;
        this._distanceOfPathTween = 0;
        this._distanceOfNextPathTween = 0;
        this._lerpDirection = null;

        this.position = new BABYLON.Vector3(this._currentWaypoint.position.x, this._currentWaypoint.position.y, this._currentWaypoint.position.z);
        this.position.y += this._cameraHeight;

        if (this._travelIndex == 0) {
            this._travelingPath = null;
            this._waypointDestination = null;
            this.highlightClosestPath();
        }
        else {
            this._waypointDestination = this._travelingPath.wayPoints[this._travelIndex];
            this._travelIndex--;
            this._currentWaypoint = this._travelingPath.wayPoints[this._travelIndex];
            this.calculateNextWaypoint();
        }

        return true;
    }

    public _checkInputs(): void {
        if (this.cameraRotation.x != 0 || this.cameraRotation.y != 0) {
            this._distanceOfPathTween = 0;
            this._distanceOfNextPathTween = 0;
            this._distanceToTweenToNextPath = 0;
            this._lerpDirection = null;
        }

        if (this._onKeyDown) {
            var timeDiff = (BABYLON.Tools.Now - this._timeSinceFrameUpdate) / 1000;

            if (timeDiff > 1) {
                timeDiff = 1;
            }

            var camera = this;
            if (this._velocity != 0) {
                camera.moveAlongPath(this._velocity * timeDiff);
            }
            if (this.rotationChange != 0) {
                camera.rotation.y += camera.rotationChange * timeDiff;
            }
        }

        this._timeSinceFrameUpdate = BABYLON.Tools.Now;
        super._checkInputs.call(this);
    }
}

export default FollowCamera;